<template>
  <div
    class="relative flex h-full flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-sm"
  >
    <div
      v-if="accent"
      :class="['absolute top-0 left-0 h-[3px] w-full', accent]"
    />
    <div
      v-if="title || $slots.header"
      class="flex items-center justify-between border-b border-neutral-300 bg-neutral-200 px-6 py-4"
    >
      <div v-if="title" class="flex-1">
        <h3 class="text-navy-800 text-sm font-semibold">{{ title }}</h3>
        <p v-if="subtitle" class="text-navy-500 mt-0.5 text-sm">
          {{ subtitle }}
        </p>
      </div>
      <slot name="header" />
      <div v-if="$slots.actions" class="ml-4">
        <slot name="actions" />
      </div>
    </div>
    <div :class="['flex-1', noPadding ? '' : 'p-5']">
      <slot />
    </div>
    <div v-if="$slots.footer" class="border-t border-neutral-100 px-6 py-3">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  subtitle?: string
  noPadding?: boolean
  accent?: string
}

withDefaults(defineProps<Props>(), {
  title: undefined,
  subtitle: undefined,
  noPadding: false,
  accent: undefined,
})
</script>
